// src/utils/constants.js

export const INC_CATEGORIES = [
  'Salary', 'Business Income', 'Freelance', 'Investment Return',
  'Rental Income', 'Gift Received', 'Bonus', 'Other Income',
]

export const EXP_CATEGORIES = [
  'Food & Dining', 'Rent / Mortgage', 'Groceries', 'Transport',
  'Utilities', 'Healthcare', 'Shopping', 'Entertainment',
  'Education', 'EMI / Loan', 'Insurance', 'Charity',
  'Subscriptions', 'Personal Care', 'Other Expense',
]

export const ACCOUNT_TYPES = [
  'Cash', 'Bank', 'Credit Card', 'Savings', 'Investment', 'Wallet',
]

export const ACCOUNT_COLORS = [
  '#1c3a5e', '#0a6640', '#a32d2d', '#854f0b', '#5e35b1', '#0f6e56',
  '#185fa5', '#6d3b00', '#3b006d', '#00546d',
]

// Category color map — text color
export const CAT_COLOR = {
  'Salary': '#0a6640', 'Business Income': '#3b6d11', 'Freelance': '#0f6e56',
  'Investment Return': '#085041', 'Rental Income': '#185fa5',
  'Gift Received': '#5e35b1', 'Bonus': '#0a6640', 'Other Income': '#27500a',
  'Food & Dining': '#993c1d', 'Rent / Mortgage': '#a32d2d',
  'Groceries': '#854f0b', 'Transport': '#633806', 'Utilities': '#854f0b',
  'Healthcare': '#a32d2d', 'Shopping': '#993556', 'Entertainment': '#712b13',
  'Education': '#0c447c', 'EMI / Loan': '#791f1f', 'Insurance': '#5f5e5a',
  'Charity': '#185fa5', 'Subscriptions': '#5e35b1',
  'Personal Care': '#712b13', 'Other Expense': '#5f5e5a',
  'Transfer': '#185fa5',
}

// Category background color
export const CAT_BG = {
  'Salary': '#e6f4ec', 'Business Income': '#eaf3de', 'Freelance': '#e1f5ee',
  'Investment Return': '#e1f5ee', 'Rental Income': '#e6f1fb',
  'Gift Received': '#ede7f6', 'Bonus': '#e6f4ec', 'Other Income': '#eaf3de',
  'Food & Dining': '#faece7', 'Rent / Mortgage': '#fcebeb',
  'Groceries': '#faeeda', 'Transport': '#faeeda', 'Utilities': '#faeeda',
  'Healthcare': '#fcebeb', 'Shopping': '#fbeaf0', 'Entertainment': '#faece7',
  'Education': '#e6f1fb', 'EMI / Loan': '#fcebeb', 'Insurance': '#f1efe8',
  'Charity': '#e6f1fb', 'Subscriptions': '#ede7f6',
  'Personal Care': '#faece7', 'Other Expense': '#f1efe8',
  'Transfer': '#e6f1fb',
}



